import FastImage from "../../../../globals/elements/fastimg";
import { publicUrlFor } from "../../../../globals/constants";

function SectionHome1Testimonials() {
    return (
        <div className="section-full  p-b80 bg-center bg-full-height bg-no-repeat bg-white" style={{ backgroundImage: `url(${publicUrlFor("images/background/bg-map.png")})` }}>
            <div className="container">
                {/* TITLE START */}
                <div className="section-head text-center">
                    {/* <h2 data-title="Testimonials">Our Client Say</h2> */}
                    <div className="mt-separator-outer">
                        <div className=" site-bg-primary" />
                    </div>
                </div>
                {/* TITLE END */}
                {/* <div className="section-content">
                    <div className="owl-carousel home-carousel-1">
                        <div className="item">
                            <div className="testimonial-2  clearfix bg-white">
                                <div className="testimonial-detail">
                                    <div className="testimonial-pic shadow"><FastImage src="images/testimonials/pic1.jpg" width={100} height={100} alt="" /></div>
                                </div>
                                <div className="testimonial-text">
                                    <strong className="testimonial-name">Yamama Asian Mart </strong>
                                    <span className="testimonial-position">Kuwait</span>
                                    <span className="fa fa-quote-left" />
                                    <p> Great storage experience! Everything was handled carefully, and the communication was excellent. We feel confident storing my products with EZ Storage.</p>
                                </div>
                            </div>
                        </div>
                        <div className="item">
                            <div className="testimonial-2 clearfix bg-white">
                                <div className="testimonial-detail ">
                                    <div className="testimonial-pic shadow"><FastImage src="images/testimonials/pic2.jpg" width={100} height={100} alt="" /></div>
                                </div>
                                <div className="testimonial-text">
                                    <strong className="testimonial-name">Zenith Group</strong>
                                    <span className="testimonial-position">Kuwait</span>
                                    <span className="fa fa-quote-left" />
                                    <p> Excellent facility with friendly staff. They helped us organize our goods perfectly. Easy access, quick response, and great service overall!</p>
                                </div>
                            </div>
                        </div>
                    
                    </div>
                </div> */}
            </div>
        </div>
    )
}

export default SectionHome1Testimonials;
